import {
    SHOW_USER_MODAL,
    HIDE_USER_MODAL,
    CHANGE_ROLE,
    GET_SANITARY_BOOK,
    UPDATE_SANITARY_BOOK,
} from './userDetails.actionsTypes';
import axios from 'axios';
import { BASE_URL } from '../../config';
import { UPDATE_DISTRIBUTOR } from '../../components/distributors/distributors.actionTypes';

export const showUserModal = (user) => {
    return {
        type: SHOW_USER_MODAL,
        user
    };
};

export const fetchUserAndShowModal = (userId, role) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/${role}/${userId}`)
            .then((response) => {
                dispatch({
                    type: SHOW_USER_MODAL,
                    user: response.data
                });
            })
            .catch((error) => {
                console.error("Error fetching user details:", error);
            });
    };
};

export const hideUserModal = () => {
    return {
        type: HIDE_USER_MODAL
    };
};

export const changeRole = (changedRole) => {
    return {
        type: CHANGE_ROLE,
        changedRole
    };
};

export const fetchSanitaryBook = (distributorId) => {
    return (dispatch) => {
        return axios.get(`${BASE_URL}delivery/sanitary-book/${distributorId}`)
            .then((response) => {
                dispatch({
                    type: GET_SANITARY_BOOK,
                    sanitaryBook: response.data
                });
                return response;
            })
            .catch((error) => {
                console.error("Error fetching sanitary book details:", error);
                throw error;
            });
    };
};

export const reviewSanitaryBook = (id, data, distributorId) => {
    return (dispatch) => {
        return axios.post(`${BASE_URL}delivery/sanitary-book/${id}`, data)
            .then((response) => {
                dispatch({
                    type: UPDATE_SANITARY_BOOK,
                    sanitaryBook: response.data
                });
                const updatedBook = response.data || {};
                const distId = distributorId
                    || (updatedBook.distributor && (updatedBook.distributor._id || updatedBook.distributor));
                if (distId && data && typeof data.status === "number") {
                    dispatch({
                        type: UPDATE_DISTRIBUTOR,
                        distributor: {
                            id: distId,
                            sanitaryBookStatus: data.status,
                        },
                    });
                }
                return response;
            })
            .catch((error) => {
                console.error("Error reviewing sanitary book:", error);
                throw error;
            });
    };
};
